export const funcionesGeneralesMixins = {
  methods: {
    obtencionDeModuloPorUrl() {
    },
  },
};

/**
 * @author Miguel González.
 * @description funcion que crea un objeto con la estructure de roles que tiene el usuario.
 * first modified 26-04-2023 12:25 
 * last modified 14-08-2023 11:54 */
export const userRolStructure = (modules, sections, roleStructure, userStructure) => {
  const roleTree = [{
    idModule: 0,
    nameModule: '',
    sections: [],
  }];
  const userTree = [{
    idModule: 0,
    nameModule: '',
    sections: [],
  }];
  const userRoles = roleStructure.filter(({ id_status, active }) => id_status !== 0 && active !== 0);
  const rolesByUser = userStructure.filter(({ id_status, active }) => id_status !== 0 && active !== 0);

  modules.map(({ id, name }) => {
    rolesByUser.map(({ id_module }) => {
      if (id === id_module) {
        if (!userTree.find(({ idModule }) => idModule === id)) {
          userTree.push({
            idModule: id,
            nameModule: name,
            sections: []
          });
        }
      }
    });
  });

  modules.map(({ id, name }) => {
    userRoles.map(({ id_module, active }) => {
      if (id === id_module && active === 1) {
        if (!roleTree.find(({ idModule }) => idModule === id)) {
          roleTree.push({
            idModule: id,
            nameModule: name,
            sections: []
          });
        }
      }
    });
  });

  userRoles.map(({ id_module, id_sections, id_subsection, active, id_role }) => {
    if (active === 1) {
      if (id_role !== 9999) {
        if (roleTree.find(role => role.idModule === id_module).sections.length === 0) {
          roleTree.find(role => role.idModule === id_module).sections.push({
            idSection: id_sections,
            nameSection: sections.find(section => section.id === id_sections).name,
            subSections: [{
              idSubsection: sections.find(sections => sections.id === id_subsection).id,
              nameSubsection: sections.find(sections => sections.id === id_subsection).name,
            }]
          });
        } else {
          if (roleTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
            roleTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
              idSubsection: sections.find(sections => sections.id === id_subsection).id,
              nameSubsection: sections.find(sections => sections.id === id_subsection).name,
            });
          } else {
            roleTree.find(role => role.idModule === id_module).sections.push({
              idSection: id_sections,
              nameSection: sections.find(section => section.id === id_sections).name,
              subSections: [{
                idSubsection: sections.find(sections => sections.id === id_subsection).id,
                nameSubsection: sections.find(sections => sections.id === id_subsection).name,
              }]
            });
          }
        }
      } else {
        if (id_module === 7) {
          roleTree.find(role => role.idModule === id_module).sections.push({
            idSection: id_sections,
            nameSection: sections.find(section => section.id === id_sections).name,
            subSections: [{
              idSubsection: sections.find(sections => sections.id === id_subsection).id,
              nameSubsection: sections.find(sections => sections.id === id_subsection).name,
            }]
          });
        }
      }
    }
  });

  rolesByUser.map(({ id_module, id_sections, id_subsection }) => {
    if (userRoles.find(({ id_module: urIdModule, id_sections: udIdSection, id_subsection: udIdSubsection }) => urIdModule === id_module && udIdSection === id_sections && udIdSubsection === id_subsection)) {
      switch (id_module) {
        case 1:
          if (userTree.find(userRole => userRole.idModule === id_module)) {
            if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                }]
              })
            } else {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                userTree.find(userRole => userRole.idModule === id_module).sections.push({
                  idSection: id_sections,
                  nameSection: sections.find(section => section.id === id_sections).name,
                  subSections: [{
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  }]
                })
              }

              if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                  userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  })
                }
              }
            }
          }
          break;
        case 2:
          if (userTree.find(userRole => userRole.idModule === id_module)) {
            if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                }]
              })
            } else {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                userTree.find(userRole => userRole.idModule === id_module).sections.push({
                  idSection: id_sections,
                  nameSection: sections.find(section => section.id === id_sections).name,
                  subSections: [{
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  }]
                })
              }

              if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                  userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  })
                }
              }
            }
          }
          break;
        case 3:
          if (userTree.find(userRole => userRole.idModule === id_module)) {
            if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                }]
              })
            } else {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                userTree.find(userRole => userRole.idModule === id_module).sections.push({
                  idSection: id_sections,
                  nameSection: sections.find(section => section.id === id_sections).name,
                  subSections: [{
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  }]
                })
              }

              if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                  userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  })
                }
              }
            }
          }
          break;
        case 4:
          if (userTree.find(userRole => userRole.idModule === id_module)) {
            if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                }]
              })
            } else {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                userTree.find(userRole => userRole.idModule === id_module).sections.push({
                  idSection: id_sections,
                  nameSection: sections.find(section => section.id === id_sections).name,
                  subSections: [{
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  }]
                })
              }

              if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                  userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  })
                }
              }
            }
          }
          break;
        case 5:

          if (userTree.find(userRole => userRole.idModule === id_module)) {
            if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                }]
              })
            } else {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                userTree.find(userRole => userRole.idModule === id_module).sections.push({
                  idSection: id_sections,
                  nameSection: sections.find(section => section.id === id_sections)?.name,
                  subSections: [{
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  }]
                })
              }

              if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                  userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  })
                }
              }
            }
          }

          break;
        case 6:
          if (userTree.find(userRole => userRole.idModule === id_module)) {
            if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                }]
              })
            } else {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                userTree.find(userRole => userRole.idModule === id_module).sections.push({
                  idSection: id_sections,
                  nameSection: sections.find(section => section.id === id_sections).name,
                  subSections: [{
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  }]
                })
              }

              if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                  userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  })
                }
              }
            }
          }
          break;
        case 7:
          if (userTree.find(userRole => userRole.idModule === id_module)) {
            if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                }]
              })
            } else {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                userTree.find(userRole => userRole.idModule === id_module).sections.push({
                  idSection: id_sections,
                  nameSection: sections.find(section => section.id === id_sections).name,
                  subSections: [{
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  }]
                })
              }

              if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
                if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                  userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                    idSubsection: sections.find(sections => sections.id === id_subsection).id,
                    nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  })
                }
              }
            }
          }
          break;

        default:
          break;
      }
    }
  });

  return {
    roleTree,
    userTree,
  };
}

/**
 * @author Miguel González.
 * @description funcion que retornan si estan activas las secciones correspondiente al usuario logeado.
 * last modified 26-04-2023 12:25 */
export const validAdministracion = (roleStructure, userStructure) => {
  let showLimitePlanificaciones = false;
  let showZonasDeConsolidacion = false;
  let showDivisionTerritorial = false;
  let showCategoriaProductos = false;
  let showTiposDeMovimiento = false;
  let showPalletsYDerivados = false;
  let showSubContenedores = false;
  let showPuertosYPaises = false;
  let showContenedores = false;
  let showProveedores = false;
  let showCondiciones = false;
  let showAtmosferas = false;
  let showTemporadas = false;
  let showEmbarcador = false;
  let showDepositos = false;
  let showNavieras = false;
  let showDestinos = false;
  let showClientes = false;
  let showUsuarios = false;
  let showEspecies = false;
  let showEmpresas = false;
  let showPallets = false;
  let showPuertos = false;
  let showPaises = false;
  let showNaves = false;

  const administracionRoleStructure = roleStructure?.find(({ idModule }) => idModule === 5);
  if (administracionRoleStructure) {
    administracionRoleStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 221: showCategoriaProductos = true; break;
        case 3: showUsuarios = true; break;
        case 2: showClientes = true; break;
        case 220:
          showPuertosYPaises = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 48: showDestinos = true; break;
              case 7: showPuertos = true; break;
              case 54: showPaises = true; break;
              default: break;
            }
          });
          break;
        case 9:
          showContenedores = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 51: showZonasDeConsolidacion = true; break;
              case 50: showTiposDeMovimiento = true; break;
              case 47: showSubContenedores = true; break;
              case 49: showAtmosferas = true; break;
              case 48: showDepositos = true; break;
              default: break;
            }
          });
          break;
        case 218:
          showPalletsYDerivados = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 11: showCondiciones = true; break;
              case 219: showEspecies = true; break;
              case 10: showPallets = true; break;
              case 12: showNaves = true; break;
              default: break;
            }
          });
          break;
        case 15: showLimitePlanificaciones = true; break;
        case 223: showDivisionTerritorial = true; break;
        case 5: showProveedores = true; break;
        case 16: showTemporadas = true; break;
        case 17: showEmbarcador = true; break;
        case 222: showEmpresas = true; break;
        case 13: showNavieras = true; break;


        default:
          break;
      }
    });
  }

  const administracionUserStructure = userStructure?.find(({ idModule }) => idModule === 5);
  if (administracionUserStructure) {
    administracionUserStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 221: showCategoriaProductos = true; break;
        case 3: showUsuarios = true; break;
        case 2: showClientes = true; break;
        case 220:
          showPuertosYPaises = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 48: showDestinos = true; break;
              case 7: showPuertos = true; break;
              case 54: showPaises = true; break;
              default: break;
            }
          });
          break;
        case 9:
          showContenedores = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 51: showZonasDeConsolidacion = true; break;
              case 50: showTiposDeMovimiento = true; break;
              case 47: showSubContenedores = true; break;
              case 49: showAtmosferas = true; break;
              case 48: showDepositos = true; break;
              default: break;
            }
          });
          break;
        case 218:
          showPalletsYDerivados = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 11: showCondiciones = true; break;
              case 219: showEspecies = true; break;
              case 10: showPallets = true; break;
              case 12: showNaves = true; break;
              default: break;
            }
          });
          break;
        case 15: showLimitePlanificaciones = true; break;
        case 223: showDivisionTerritorial = true; break;
        case 5: showProveedores = true; break;
        case 16: showTemporadas = true; break;
        case 17: showEmbarcador = true; break;
        case 222: showEmpresas = true; break;
        case 13: showNavieras = true; break;


        default:
          break;
      }
    });
  }

  if (JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') {
    showLimitePlanificaciones = true;
    showZonasDeConsolidacion = true;
    showDivisionTerritorial = true;
    showCategoriaProductos = true;
    showPalletsYDerivados = true;
    showTiposDeMovimiento = true;
    showSubContenedores = true;
    showPuertosYPaises = true;
    showContenedores = true;
    showCondiciones = true;
    showProveedores = true;
    showEmbarcador = true;
    showAtmosferas = true;
    showTemporadas = true;
    showDepositos = true;
    showClientes = true;
    showDestinos = true;
    showUsuarios = true;
    showEspecies = true;
    showEmpresas = true;
    showNavieras = true;
    showPuertos = true;
    showPallets = true;
    showPaises = true;
    showNaves = true;
  };

  return {
    showLimitePlanificaciones,
    showZonasDeConsolidacion,
    showDivisionTerritorial,
    showCategoriaProductos,
    showTiposDeMovimiento,
    showPalletsYDerivados,
    showSubContenedores,
    showPuertosYPaises,
    showContenedores,
    showCondiciones,
    showProveedores,
    showTemporadas,
    showAtmosferas,
    showEmbarcador,
    showDepositos,
    showClientes,
    showDestinos,
    showUsuarios,
    showEspecies,
    showEmpresas,
    showNavieras,
    showPallets,
    showPuertos,
    showPaises,
    showNaves,
  }
}

//in development
export const validCharter = (roleStructure, userStructure) => {

  let showPlanificacionSemanal = false;
  let showPlanificacionAnual = false;
  let showDeclaracionPorNave = false;
  let showBuscarItinerarios = false;
  let showSubItinerarios = false;
  let showItinerarios = false;
  let showServicios = false;
  let showGeneral = false;
  //SI

  let showSi = false;
  let showPorEnviar = false;
  let showEnviadas = false;
  let showTemplates = false;
  let showCharterReporte = false;


  const charterRoleStructure = roleStructure?.find(({ idModule }) => idModule === 2);
  if (charterRoleStructure) {
    charterRoleStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 28: showPlanificacionSemanal = true; break;
        case 27: showPlanificacionAnual = true; break;
        case 30: showDeclaracionPorNave = true; break;
        case 29: showServicios = true; break;
        case 31: showGeneral = true; break;
        case 32: //itinerarios
          showItinerarios = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 226: showBuscarItinerarios = true; break;
              case 225: showSubItinerarios = true; break;
              default: break;
            }
          });
          break;
        case 256: //SI
          showSi = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 257: showPorEnviar = true; break;
              case 258: showEnviadas = true; break;
              case 260: showTemplates = true; break;
              default: break;
            }
          });
          break;
        case 259: showCharterReporte = true; break;
        default: break;
      }
    });
  }

  const charterUserStructure = userStructure?.find(({ idModule }) => idModule === 2);
  if (charterUserStructure) {
    charterUserStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 28: showPlanificacionSemanal = true; break;
        case 27: showPlanificacionAnual = true; break;
        case 30: showDeclaracionPorNave = true; break;
        case 29: showServicios = true; break;
        case 31: showGeneral = true; break;
        case 32: //itinerarios
          showItinerarios = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 226: showBuscarItinerarios = true; break;
              case 225: showSubItinerarios = true; break;
              default: break;
            }
          });
          break;
        case 256: //SI
          showSi = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 257: showPorEnviar = true; break;
              case 258: showEnviadas = true; break;
              case 260: showTemplates = true; break;
              default: break;
            }
          });
          break;
        case 259: showCharterReporte = true; break;
        default: break;
      }
    });
  }

  if (JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') {
    showPlanificacionSemanal = true;
    showPlanificacionAnual = true;
    showDeclaracionPorNave = true;
    showBuscarItinerarios = true;
    showSubItinerarios = true;
    showItinerarios = true;
    showServicios = true;
    showGeneral = true;

    showSi = true;
    showPorEnviar = true;
    showEnviadas = true;
    showTemplates = true;
    showCharterReporte = true;
  }

  return {
    showPlanificacionSemanal,
    showPlanificacionAnual,
    showDeclaracionPorNave,
    showBuscarItinerarios,
    showSubItinerarios,
    showItinerarios,
    showServicios,
    showGeneral,
    showSi,
    showPorEnviar,
    showEnviadas,
    showTemplates,
    showCharterReporte
  }
}

export const validLineas = (roleStructure, userStructure) => {
  let showSolicitudesModificacion = false;
  let showReporteTarifaEmbarcados = false;
  let showImportadorCotizaciones = false;
  let showMisBookingsPorAceptar = false;
  let showPlanificacionSemanal = false;
  let showBookingNoPlanificado = false;
  let showBookingsPorConfirmar = false;
  let showDeclaradosCancelados = false;
  let showAcuerdosClientesBase = false;
  let showBookingsSolicitados = false;
  let showBookingsConfirmados = false;
  let showPlanificacionAnual = false;
  let showBookingPlanificado = false;
  let showBookingsDeclarados = false;
  let showBookingsEmbarcados = false;
  let showBookingsCancelados = false;
  let showDescuentosClientes = false;
  let showBuscarItinerarios = false;
  let showAcuerdosClientes = false;
  let showVerLateArrivals = false;
  let showSubItinerarios = false;
  let showAcuerdosLineas = false;
  let showTarifasLineas = false;
  let showLateArrivals = false;
  let showItinerarios = false;
  let showServicios = false;
  let showContratos = false;
  let showTracking = false;
  let showBuscarBL = false;
  let showBooking = false;
  let showGeneral = false;
  let showTarifas = false;
  let showRecargos = false;


  const lineasRoleStructure = roleStructure?.find(({ idModule }) => idModule === 1);
  if (lineasRoleStructure) {
    lineasRoleStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 20: showPlanificacionSemanal = true; break;
        case 19: showPlanificacionAnual = true; break;
        case 227: showBuscarBL = true; break;
        case 21: showServicios = true; break;
        case 22: //bookings
          showBooking = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 62: showSolicitudesModificacion = true; break;
              case 230: showMisBookingsPorAceptar = true; break;
              case 231: showBookingsPorConfirmar = true; break;
              case 229: showBookingNoPlanificado = true; break;
              case 65: showDeclaradosCancelados = true; break;
              case 247: showDeclaradosCancelados = true; break;
              case 61: showBookingsConfirmados = true; break;
              case 60: showBookingsSolicitados = true; break;
              case 228: showBookingPlanificado = true; break;
              case 59: showBookingsDeclarados = true; break;
              case 63: showBookingsEmbarcados = true; break;
              case 64: showBookingsCancelados = true; break;
              case 68: showVerLateArrivals = true; break;
              case 66: showLateArrivals = true; break;
              // case 67: showSolicitudReserva = true; break; // por construir
              default: break;
            }
          });
          break;
        case 23: showGeneral = true; break;
        case 24: //tarifas
          showTarifas = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 238: showReporteTarifaEmbarcados = true; break;
              case 234: showAcuerdosClientesBase = true; break;
              case 237: showDescuentosClientes = true; break;
              case 235: showAcuerdosClientes = true; break;
              case 233: showAcuerdosLineas = true; break;
              case 236: showTarifasLineas = true; break;
              case 232: showContratos = true; break;
              case 248: showRecargos = true; break;
              case 261: showImportadorCotizaciones = true; break;
              default: break;
            }
          });
          break;
        case 25: //itinerarios
          showItinerarios = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 239: showSubItinerarios = true; break;
              case 240: showBuscarItinerarios = true; break;
              default: break;
            }
          });
          break;
        case 69: showTracking = true; break;
        default: break;
      }
    });
  }
  const lineasUserStructure = userStructure?.find(({ idModule }) => idModule === 1);
  if (lineasUserStructure) {
    lineasUserStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 20: showPlanificacionSemanal = true; break;
        case 19: showPlanificacionAnual = true; break;
        case 227: showBuscarBL = true; break;
        case 21: showServicios = true; break;
        case 22: //bookings
          showBooking = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 62: showSolicitudesModificacion = true; break;
              case 230: showMisBookingsPorAceptar = true; break;
              case 231: showBookingsPorConfirmar = true; break;
              case 229: showBookingNoPlanificado = true; break;
              case 65: showDeclaradosCancelados = true; break;
              case 61: showBookingsConfirmados = true; break;
              case 60: showBookingsSolicitados = true; break;
              case 228: showBookingPlanificado = true; break;
              case 59: showBookingsDeclarados = true; break;
              case 63: showBookingsEmbarcados = true; break;
              case 64: showBookingsCancelados = true; break;
              case 68: showVerLateArrivals = true; break;
              case 66: showLateArrivals = true; break;
              // case 67: showSolicitudReserva = true; break; // por construir
              default: break;
            }
          });
          break;
        case 23: showGeneral = true; break;
        case 24: //tarifas
          showTarifas = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 238: showReporteTarifaEmbarcados = true; break;
              case 234: showAcuerdosClientesBase = true; break;
              case 237: showDescuentosClientes = true; break;
              case 235: showAcuerdosClientes = true; break;
              case 233: showAcuerdosLineas = true; break;
              case 236: showTarifasLineas = true; break;
              case 232: showContratos = true; break;
              case 261: showImportadorCotizaciones = true; break;
              default: break;
            }
          });
          break;
        case 25: //itinerarios
          showItinerarios = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 239: showSubItinerarios = true; break;
              case 240: showBuscarItinerarios = true; break;
              default: break;
            }
          });
          break;
        case 69: showTracking = true; break;
        default: break;
      }
    });
  }

  if (JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') {
    showSolicitudesModificacion = true;
    showReporteTarifaEmbarcados = true;
    showImportadorCotizaciones = true;
    showMisBookingsPorAceptar = true;
    showPlanificacionSemanal = true;
    showBookingNoPlanificado = true;
    showBookingsPorConfirmar = true;
    showDeclaradosCancelados = true;
    showAcuerdosClientesBase = true;
    showBookingsSolicitados = true;
    showBookingsConfirmados = true;
    showPlanificacionAnual = true;
    showBookingPlanificado = true;
    showBookingsDeclarados = true;
    showBookingsEmbarcados = true;
    showBookingsCancelados = true;
    showDescuentosClientes = true;
    showBuscarItinerarios = true;
    showAcuerdosClientes = true;
    showVerLateArrivals = true;
    showSubItinerarios = true;
    showAcuerdosLineas = true;
    showTarifasLineas = true;
    showLateArrivals = true;
    showItinerarios = true;
    showContratos = true;
    showServicios = true;
    showBuscarBL = true;
    showTracking = true;
    showBooking = true;
    showGeneral = true;
    showTarifas = true;
    showRecargos = true;
  }

  return {
    showSolicitudesModificacion,
    showReporteTarifaEmbarcados,
    showImportadorCotizaciones,
    showMisBookingsPorAceptar,
    showPlanificacionSemanal,
    showBookingNoPlanificado,
    showAcuerdosClientesBase,
    showBookingsPorConfirmar,
    showDeclaradosCancelados,
    showBookingsSolicitados,
    showBookingsConfirmados,
    showPlanificacionAnual,
    showBookingPlanificado,
    showBookingsDeclarados,
    showBookingsEmbarcados,
    showBookingsCancelados,
    showDescuentosClientes,
    showBuscarItinerarios,
    showAcuerdosClientes,
    showVerLateArrivals,
    showAcuerdosLineas,
    showSubItinerarios,
    showTarifasLineas,
    showLateArrivals,
    showItinerarios,
    showContratos,
    showServicios,
    showBuscarBL,
    showTracking,
    showBooking,
    showGeneral,
    showTarifas,
    showRecargos
  }
}

//in development
export const validServicioIntegral = (roleStructure, userStructure) => {
  let showServiciosLogisticosMenu = false;
  let showAdministradorDeTarifas = false;
  let showTarifasProveedoresExtraCosto = false;
  let showTarifasClientesExtraCostos = false;
  let showTarifasProveedoresTerrestres = false;
  let showTarifasProveedoresDocumentales = false;
  let showTarifasClientesTerrestres = false;
  let showTarifasClientesDocumentales = false;

  const administracionRoleStructure = roleStructure?.find(({ idModule }) => idModule === 9);

  if ( administracionRoleStructure ) {
    administracionRoleStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 276: 
          showServiciosLogisticosMenu = true; 
          showAdministradorDeTarifas = true; 
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 270:
               showTarifasProveedoresExtraCosto = true;
                break;
              case 271:
               showTarifasClientesExtraCostos = true;
                break;
              case 272:
               showTarifasProveedoresTerrestres = true;
                break;
              case 273:
               showTarifasProveedoresDocumentales = true; 
                break;
              case 274:
               showTarifasClientesTerrestres  = true;
                break;
              case 275:
               showTarifasClientesDocumentales  = true;
                break;
            }
          });
      }
    });

  }

  const administracionUserStructure = userStructure?.find(({ idModule }) => idModule === 9);

  if ( administracionUserStructure ) {
    administracionUserStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 276: 
         showServiciosLogisticosMenu = true; 
         showAdministradorDeTarifas = true; 
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 270:
               showTarifasProveedoresExtraCosto = true;
                break;
              case 271:
               showTarifasClientesExtraCostos = true;
                break;
              case 272:
               showTarifasProveedoresTerrestres = true;
                break;
              case 273:
               showTarifasProveedoresDocumentales = true; 
                break;
              case 274:
               showTarifasClientesTerrestres  = true;
                break;
              case 275:
               showTarifasClientesDocumentales  = true;
                break;
            }
          });
      }
    });

  }

  if (JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') {

    showServiciosLogisticosMenu = true;
    showAdministradorDeTarifas = true;
    showTarifasProveedoresExtraCosto = true;
    showTarifasClientesExtraCostos = true;
    showTarifasProveedoresTerrestres = true;
    showTarifasProveedoresDocumentales = true;
    showTarifasClientesTerrestres = true;
    showTarifasClientesDocumentales = true;
  }

  return {

    showServiciosLogisticosMenu,
    showAdministradorDeTarifas,
    showTarifasProveedoresExtraCosto,
    showTarifasClientesExtraCostos,
    showTarifasProveedoresTerrestres,
    showTarifasProveedoresDocumentales,
    showTarifasClientesTerrestres,
    showTarifasClientesDocumentales
  }
}

//in development
export const validSIFinanzas = (roleStructure, userStructure) => {
  let showVincularCostoCompraNoContable = false;
  let showVincularCostoVentaNoContable = false;
  let showVincularCostoCompra = false;
  let showVincularCostoVenta = false;
  let showOrdenesDeServicio = false;
  let showResumenProveedor = false;
  let showCompraNoContable = false;
  let showResumenCliente = false;
  let showNoContable = false;
  let showContable = false;
  let showCompra = false;
  let showVenta = false;

  const servIntFinanzasRoleStructure = roleStructure?.find(({ idModule }) => idModule === 4);
  if (servIntFinanzasRoleStructure) {
    servIntFinanzasRoleStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 37: showOrdenesDeServicio = true; break;
        case 38: // Contable
          showContable = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 98: showVincularCostoCompra = true; break;
              case 100: showVincularCostoVenta = true; break;
              case 97: showCompra = true; break;
              case 99: showVenta = true; break;
              default: break;
            }
          });

          break;
        case 39:
          showNoContable = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 102: showVincularCostoCompraNoContable = true; break;
              case 103: showVincularCostoVentaNoContable = true; break;
              case 101: showCompraNoContable = true; break;
              default: break;
            }
          });
          break;
        case 41: showResumenProveedor = true; break;
        case 40: showResumenCliente = true; break;

        default:
          break;
      }
    });
  }
  const servIntFinanzasUserStructure = userStructure?.find(({ idModule }) => idModule === 4);
  if (servIntFinanzasUserStructure) {
    servIntFinanzasUserStructure.sections.map(({ idSection, subSections }) => {
      switch (idSection) {
        case 37: showOrdenesDeServicio = true; break;
        case 38: // Contable
          showContable = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 98: showVincularCostoCompra = true; break;
              case 100: showVincularCostoVenta = true; break;
              case 97: showCompra = true; break;
              case 99: showVenta = true; break;
              default: break;
            }
          });

          break;
        case 39:
          showNoContable = true;
          subSections.map(({ idSubsection }) => {
            switch (idSubsection) {
              case 102: showVincularCostoCompraNoContable = true; break;
              case 103: showVincularCostoVentaNoContable = true; break;
              case 101: showCompraNoContable = true; break;
              default: break;
            }
          });
          break;
        case 41: showResumenProveedor = true; break;
        case 40: showResumenCliente = true; break;

        default:
          break;
      }
    });
  }

  if (JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') {
    showVincularCostoCompraNoContable = true;
    showVincularCostoVentaNoContable = true;
    showVincularCostoCompra = true;
    showVincularCostoVenta = true;
    showOrdenesDeServicio = true;
    showCompraNoContable = true;
    showResumenProveedor = true;
    showResumenCliente = true;
    showNoContable = true;
    showContable = true;
    showCompra = true;
    showVenta = true;
  }

  showVincularCostoCompraNoContable = false;
  showVincularCostoVentaNoContable = false;
  showVincularCostoCompra = false;
  showVincularCostoVenta = false;
  showOrdenesDeServicio = false;
  showResumenProveedor = false;
  showCompraNoContable = false;
  showResumenCliente = false;
  showNoContable = false;
  showContable = false;
  showCompra = false;
  showVenta = false;

  return {
    showVincularCostoCompraNoContable,
    showVincularCostoVentaNoContable,
    showVincularCostoCompra,
    showVincularCostoVenta,
    showOrdenesDeServicio,
    showCompraNoContable,
    showResumenProveedor,
    showResumenCliente,
    showNoContable,
    showContable,
    showCompra,
    showVenta,
  }
}

export const validShipping = (roleStructure, userStructure) => {
  let showShippingInstructionsConfirmados = false;
  let showShippingInstructionsRechazados = false;
  let showShippingInstructionsPorEnviar = false;
  let showShippingInstructionsEnviados = false;
  let showShippingInstructionsPorAprobar = false;
  let showShippingInstructionsPorRealizar = false;
  let showAñadirShippingInstruction = false;
  let showTemplates = false;
  let showReportes = false;

  const shippingInstructionRoleStructure = roleStructure?.find(({ idModule }) => idModule === 6);
  if (shippingInstructionRoleStructure) {
    shippingInstructionRoleStructure.sections.map(({ idSection }) => {
      switch (idSection) {
        case 245: showShippingInstructionsRechazados = true; break;
        case 45: showShippingInstructionsConfirmados = true; break;
        case 43: showShippingInstructionsPorEnviar = true; break;
        case 44: showShippingInstructionsEnviados = true; break;
        case 244: showAñadirShippingInstruction = true; break;
        case 246: showReportes = true; break;
        case 46: showTemplates = true; break;
        case 251: showShippingInstructionsPorAprobar = true; break;
        case 252: showShippingInstructionsPorRealizar = true; break;
        //falta shipping instructions reportes
        //falta shipping instruction rechazados

        default:
          break;
      }
    });
  }
  const shippingInstructionUserStructure = userStructure?.find(({ idModule }) => idModule === 6);
  if (shippingInstructionUserStructure) {
    shippingInstructionUserStructure.sections.map(({ idSection }) => {
      switch (idSection) {
        case 245: showShippingInstructionsRechazados = true; break;
        case 45: showShippingInstructionsConfirmados = true; break;
        case 43: showShippingInstructionsPorEnviar = true; break;
        case 44: showShippingInstructionsEnviados = true; break;
        case 244: showAñadirShippingInstruction = true; break;
        case 246: showReportes = true; break;
        case 46: showTemplates = true; break;
        case 251: showShippingInstructionsPorAprobar = true; break;
        case 252: showShippingInstructionsPorRealizar = true; break;
        //falta shipping instructions reportes
        //falta shipping instruction rechazados

        default:
          break;
      }
    });
  }

  if (JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') {
    showShippingInstructionsConfirmados = true;
    showShippingInstructionsRechazados = true;
    showShippingInstructionsPorEnviar = true;
    showShippingInstructionsEnviados = true;
    showShippingInstructionsPorAprobar = true;
    showShippingInstructionsPorRealizar = true;
    showAñadirShippingInstruction = true;
    showTemplates = true;
    showReportes = true;
  }

  return {
    showShippingInstructionsConfirmados,
    showShippingInstructionsRechazados,
    showShippingInstructionsPorEnviar,
    showShippingInstructionsEnviados,
    showShippingInstructionsPorAprobar,
    showShippingInstructionsPorRealizar,
    showAñadirShippingInstruction,
    showTemplates,
    showReportes,
  }
}

export const validSuperAdmin = (roleStructure, userStructure) => {
  let showMantenedorRegional = false;
  let showSecciones = false;
  let showFiliales = false;
  let showModulos = false;
  let showRoles = false;
  const superAdminRoleStructure = roleStructure?.find(({ idModule }) => idModule === 7);
  if (superAdminRoleStructure) {
    superAdminRoleStructure.sections.map(({ idSection }) => {
      switch (idSection) {
        case 6: showMantenedorRegional = true; break;
        case 105: showSecciones = true; break;
        case 214: showFiliales = true; break;
        case 104: showModulos = true; break;
        case 52: showRoles = true; break;
        case 4: showRoles = true; break;
        default: break;
      }
    });
  }
  const superAdminUserStructure = userStructure?.find(({ idModule }) => idModule === 7);
  if (superAdminUserStructure) {
    superAdminUserStructure.sections.map(({ idSection }) => {
      switch (idSection) {
        case 6: showMantenedorRegional = true; break;
        case 105: showSecciones = true; break;
        case 214: showFiliales = true; break;
        case 104: showModulos = true; break;
        case 52: showRoles = true; break;
        case 4: showRoles = true; break;
        default: break;
      }
    });
  }

  return {
    showMantenedorRegional,
    showSecciones,
    showFiliales,
    showModulos,
    showRoles,
  }
}

export const userStructureFormat = (modules, sections, userStructure) => {

  const userTree = [{
    idModule: 0,
    nameModule: '',
    sections: [],
  }];

  modules.map(({ id, name }) => {
    userStructure.map(({ id_module, id_status, id: idStructure }) => {
      if (id_status !== 0) {
        if (id === id_module) {
          if (!userTree.find(({ idModule }) => idModule === id)) {
            userTree.push({
              idModule: id,
              nameModule: name,
              sections: [],
              active: id_status === 1 ? true : false,
              idStructure: idStructure
            });
          }
        }
      }
    });
  });

  userStructure.map(({ id_module, id_sections, id_subsection, id, id_status }) => {
    switch (id_module) {
      case 1:
        if (userTree.find(userRole => userRole.idModule === id_module)) {
          if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
            userTree.find(userRole => userRole.idModule === id_module).sections.push({
              idSection: id_sections,
              nameSection: sections.find(section => section.id === id_sections).name,
              active: id_status === 1 ? true : false,
              idStructure: id,
              subSections: [{
                idSubsection: sections.find(sections => sections.id === id_subsection).id,
                nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
              }]
            })
          } else {
            if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                }]
              })
            }

            if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                })
              }
            }
          }
        }
        break;
      case 2:
        if (userTree.find(userRole => userRole.idModule === id_module)) {
          if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
            userTree.find(userRole => userRole.idModule === id_module).sections.push({
              idSection: id_sections,
              nameSection: sections.find(section => section.id === id_sections).name,
              active: id_status === 1 ? true : false,
              idStructure: id,
              subSections: [{
                idSubsection: sections.find(sections => sections.id === id_subsection).id,
                nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
              }]
            })
          } else {
            if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                }]
              })
            }

            if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                })
              }
            }
          }
        }
        break;
      case 3:
        if (userTree.find(userRole => userRole.idModule === id_module)) {
          if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
            userTree.find(userRole => userRole.idModule === id_module).sections.push({
              idSection: id_sections,
              nameSection: sections.find(section => section.id === id_sections).name,
              active: id_status === 1 ? true : false,
              idStructure: id,
              subSections: [{
                idSubsection: sections.find(sections => sections.id === id_subsection).id,
                nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
              }]
            })
          } else {
            if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                }]
              })
            }

            if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                })
              }
            }
          }
        }
        break;
      case 4:
        if (userTree.find(userRole => userRole.idModule === id_module)) {
          if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
            userTree.find(userRole => userRole.idModule === id_module).sections.push({
              idSection: id_sections,
              nameSection: sections.find(section => section.id === id_sections).name,
              active: id_status === 1 ? true : false,
              idStructure: id,
              subSections: [{
                idSubsection: sections.find(sections => sections.id === id_subsection).id,
                nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
              }]
            })
          } else {
            if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                }]
              })
            }

            if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                })
              }
            }
          }
        }
        break;
      case 5:
        if (userTree.find(userRole => userRole.idModule === id_module)) {
          if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
            userTree.find(userRole => userRole.idModule === id_module).sections.push({
              idSection: id_sections,
              nameSection: sections.find(section => section.id === id_sections).name,
              active: id_status === 1 ? true : false,
              idStructure: id,
              subSections: [{
                idSubsection: sections.find(sections => sections.id === id_subsection).id,
                nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
              }]
            })
          } else {
            if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                }]
              })
            }

            if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                })
              }
            }
          }
        }
        break;
      case 6:
        if (userTree.find(userRole => userRole.idModule === id_module)) {
          if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
            userTree.find(userRole => userRole.idModule === id_module).sections.push({
              idSection: id_sections,
              nameSection: sections.find(section => section.id === id_sections).name,
              active: id_status === 1 ? true : false,
              idStructure: id,
              subSections: [{
                idSubsection: sections.find(sections => sections.id === id_subsection).id,
                nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
              }]
            })
          } else {
            if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                }]
              })
            }

            if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                })
              }
            }
          }
        }
        break;
      case 7:
        if (userTree.find(userRole => userRole.idModule === id_module)) {
          if (userTree.find(userRole => userRole.idModule === id_module).sections.length === 0) {
            userTree.find(userRole => userRole.idModule === id_module).sections.push({
              idSection: id_sections,
              nameSection: sections.find(section => section.id === id_sections).name,
              active: id_status === 1 ? true : false,
              idStructure: id,
              subSections: [{
                idSubsection: sections.find(sections => sections.id === id_subsection).id,
                nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
              }]
            })
          } else {
            if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              userTree.find(userRole => userRole.idModule === id_module).sections.push({
                idSection: id_sections,
                nameSection: sections.find(section => section.id === id_sections).name,
                active: id_status === 1 ? true : false,
                idStructure: id,
                subSections: [{
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                }]
              })
            }

            if (userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections)) {
              if (!userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.find(subSections => subSections.idSubsection === id_subsection)) {
                userTree.find(role => role.idModule === id_module).sections.find(section => section.idSection === id_sections).subSections.push({
                  idSubsection: sections.find(sections => sections.id === id_subsection).id,
                  nameSubsection: sections.find(sections => sections.id === id_subsection).name,
                  active: id_status === 1 ? true : false,
                  idStructure: id,
                })
              }
            }
          }
        }
        break;

      default:
        break;
    }

  });
  return userTree;
}

export const downloadFile = (data, name) => {

  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', name);
  document.body.appendChild(link)
  link.click();
}

export const formatDate = date => {

  let month = '' + (date.getUTCMonth() + 1);
  let day = '' + date.getUTCDate();
  let year = date.getUTCFullYear();

  if (month.length < 2) month = '0' + month;

  if (day.length < 2) day = '0' + day;

  return [day, month, year].join('-');
}

export const validateFormatDecimal = ( number , onlyPoints = true ) => {
  
  const search = onlyPoints ? /^-?\d+([.]\d{1,2})?$/g : /^-?\d+([.,]\d{1,2})?$/g ;

  return search.test(number);

}